module.exports = __webpack_public_path__ + "img/rmb.ebdff63c.png";